import { Typography } from "@mui/material";

interface CopyrightProps {
  [key: string]: any;
}

const Copyright: React.FC<CopyrightProps> = (props) => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {`Copyright © Insight via Artificial Intelligence`}
      {/* {new Date().getFullYear()} */}
    </Typography>
  );
};

export default Copyright;
